import {
  AndCondition,
  Condition,
  InCondition,
  IsEqualCondition,
  IsNotEqualCondition,
  NotInCondition,
  OrCondition,
} from '@/model/types';

type InvertibleConditionPairs = {
  '=': IsEqualCondition;
  '!=': IsNotEqualCondition;
  'in': InCondition;
  'not in': NotInCondition;
};

type InvertibleCondition = InvertibleConditionPairs[keyof InvertibleConditionPairs];

type InvertedOperator<T extends keyof InvertibleConditionPairs> = (typeof OPERATOR_PAIRS)[T];

type InvertedCondition<T extends InvertibleCondition> = InvertibleConditionPairs[InvertedOperator<T['operator']>];

const OPERATOR_PAIRS = {
  '=': '!=',
  '!=': '=',
  'in': 'not in',
  'not in': 'in',
} as const;

const isInvertible = (condition: Condition): condition is InvertibleCondition => condition.operator in OPERATOR_PAIRS;

export function not(condition: InvertibleCondition): InvertedCondition<typeof condition>;
export function not(condition: Condition): Condition;
export function not(condition: Condition): Condition {
  if (isInvertible(condition)) {
    return {...condition, operator: OPERATOR_PAIRS[condition.operator]} as InvertedCondition<typeof condition>;
  }
  return {operator: 'not', conditions: [condition]};
}

export const and = (...conditions: Condition[]): AndCondition => ({
  operator: 'and',
  conditions: [...conditions],
});

export const or = (...conditions: Condition[]): OrCondition => ({
  operator: 'or',
  conditions: [...conditions],
});

export const UtilsHelper = {
  not,
  and,
  or,
};
